import React from "react";
import ProductsList from "../../components/LicenseManagement/ProductsList";

function licenseManagement(props) {
  var selectedStudentId = props.location.state
    ? props.location.state.studentId
    : 0;
  var selectedClassName = props.location.state
    ? props.location.state.className
    : "";

  return (
    <ProductsList studentId={selectedStudentId} className={selectedClassName} />
  );
}

export default licenseManagement;
